// extracted by mini-css-extract-plugin
export default {"CardBaseWithSash":"drag-overlay-card-module__CardBaseWithSash__V5m8B8E"};